import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Col, Modal, Row } from "react-bootstrap";
import { login } from "store/auth";
import { useFetch, useLanguage, useToggle } from "hooks";
import { Icons, Layout } from "components";
/**
 * login page 
 */

export default function Login() {
  const dispatch = useDispatch();
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [roleId, setRoleId] = useState(null);
  const [passwordShown, togglePasswordShown] = useToggle();
  const [errors, setErrors] = useState([]);
  const [roleResponse, roleRequest] = useFetch(`getRoles`); // getting the users role to showing it in the dropdown menu

  const handleLogin = (e) =>
    dispatch(
      login({
        credentials: { username, password, role: roleId },
        onError: (error) => {
          setErrors(error);
        },
        onSuccess: () => {
          setUsername("");
          setPassword("");
          togglePasswordShown();
        },
      })
    );
  // async thunk that take credentials, onError, onSuccess

  const renderEye = () => (
    <Icons.OpenEye
      height={20}
      role="button"
      onClick={togglePasswordShown}
      className={`${
        passwordShown ? "svg-fill-black" : "svg-fill-gray"
      } absolute-arrow`}
    />
  );
  // the eye icon to hiddening and showing password text

  React.useEffect(() => {
    roleRequest();
  }, [roleRequest]);

  React.useEffect(() => {
    if (roleResponse?.result?.data && roleResponse?.result?.data.length > 0)
      setRoleId(roleResponse?.result?.data[0].id);
  }, [roleResponse?.result?.data]);

  return (
    <Layout>
      <div id="home_page" className="page_container pt-5">
        <section className="mb-3">
          <Modal.Dialog
            show={true}
            fullscreen="md-down"
            contentClassName="rounded-2 border-0"
            centered
          >
            <Modal.Header>
              <Modal.Title>{language.login}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="justify-content-center">
                <Col xs={12} className="d-flex justify-content-center my-3">
                  <img src={"/images/logo.svg"} alt="logo" />
                </Col>
                <Col
                  md={12}
                  xs={12}
                  className="d-flex justify-content-center my-4"
                >
                  <p className="fw-normal">{language.please_login}</p>
                </Col>
                <Col md={10} xs={12} className="mt-4">
                  <label
                    htmlFor="last_name"
                    className="form-label fw-medium text-light5"
                  >
                    {language.loginRole}
                  </label>
                  <div className="position-relative">
                    <select
                      id={`role`}
                      name="key"
                      type="text"
                      className={`form-control rounded-3 ${
                        typeof errors === "object" && errors.role
                          ? "border-danger"
                          : ""
                      }`}
                      value={roleId}
                      onChange={(e) => setRoleId(e.target.value)}
                      required
                      key={roleId}
                    >
                      <option
                        className="bg-white text-black"
                        value="none"
                        disabled
                      >
                        {language.allFields}
                      </option>
                      {roleResponse?.result?.data?.map(
                        ({ id, name }, index) => (
                          <option
                            key={index}
                            className="bg-white text-black"
                            value={id}
                          >
                            {name}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </Col>
                <Col md={10} xs={12} className="mt-3 mt-md-0">
                  <label
                    htmlFor="first_name"
                    className="form-label fw-medium text-light5"
                  >
                    {language.username}
                  </label>
                  <input
                    id="username"
                    className={`form-control rounded-3 ${
                      typeof errors === "object" && errors.username
                        ? "border-danger"
                        : ""
                    }`}
                    type="text"
                    placeholder={language.username}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    minLength={3}
                    required
                    autoFocus
                  />
                </Col>
                <Col md={10} xs={12} className="mt-4">
                  <label
                    htmlFor="last_name"
                    className="form-label fw-medium text-light5"
                  >
                    {language.password}
                  </label>
                  <div className="position-relative">
                    <input
                      id="password"
                      className={`form-control rounded-3 ${
                        typeof errors === "object" && errors.password
                          ? "border-danger"
                          : ""
                      }`}
                      type={passwordShown ? "text" : "password"}
                      placeholder={language.password}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      minLength={3}
                      required
                    />
                    {renderEye()}
                  </div>
                </Col>

                {errors?.length > 0 && (
                  <Col
                    lg={10}
                    xs={12}
                    className="d-flex justify-content-center my-4"
                  >
                    <small className="fw-normal text-danger">
                      * {errors[0].message}
                    </small>
                  </Col>
                )}
                {/** api errors */}
              </Row>
              <Row className="mt-4 mt-4 mt-4 ">
                <Col xs={6} />
                <Col xs={6}>
                  <button
                    className="btn btn-primary w-100"
                    onClick={handleLogin}
                  >
                    <div>{language.login}</div>
                  </button>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Dialog>
        </section>
      </div>
    </Layout>
  );
}
